
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-intermediate-html-demo-html-basic","docs-tutorial-intermediate-html-demo-html-update"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.zh.md?type=demo')
};